module.exports = __webpack_public_path__ + "static/media/alignment-options.73aa5ff2.gif";